import { useApi } from '../services';


export const useSaveQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'POST',
    {},
    {}
);

export const useGetQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'GET',
    {},
    {}
);

export const useGetQuestionnaireAnswerAsync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'GET',
    {},
    {},
    true
);

export const useDeleteQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'DELETE',
    {},
    {}
);

export const useDeleteQuestionnaireAnswerAsync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'DELETE',
    {},
    {},
    true
);

export const useCompareQuestionnairesByIdOperationSync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/compare-questionnaire-answer`,
    'POST',
    {},
    {},
    true
);

export const useSaveQuestionnaireAnswerAsync = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer`,
    'POST',
    {},
    {},
    true
);


export const useGetPetCadinStatusAsync = () => useApi(
    `/sompo/restrictive-status`,
    'POST',
    {},
    {},
    true
);

export const useGetSerasaStatusAsync = () => useApi(
    `/sompo/serasa-status`,
    'POST',
    {},
    {},
    true
);

export const useGetSerasaStatusPartnerAsync = () => useApi(
    `/sompo/serasa-status-partner`,
    'POST',
    {},
    {},
    true
);

export const useGetDefaultingStatusAsync = () => useApi(
    `/sompo/defaulting-status`,
    'POST',
    {},
    {},
    true
);

export const useCheckOperationByProductAndQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/check-operation-by-product-and-questionnaire-answer`,
    'GET',
    {},
    {}
);

export const useSaveAndExpiryQuestionnaireAnswer = (idOperation) => useApi(
    `/v2/operation/${idOperation}/questionnaire-answer-save-expiry`,
    'POST',
    {},
    {}
);